import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import SentimentDashboard from '../../components/sentimentAggregatorComponent/StockSentimentAggsWatchlist';

const WatchlistPage = () => {
  const navigate = useNavigate();
  const userId = useSelector((state) => state.auth?.user?.id);

  return (
    <div className="relative w-full min-h-screen">
      <div className="w-full bg-gradient-to-br from-gray-50 via-white to-blue-50 dark:from-gray-900 dark:via-gray-900 dark:to-blue-900/50 overflow-x-hidden">
        <div className="w-full">
          <div className="max-w-[1600px] mx-auto px-2 sm:px-4 lg:px-6 py-3 sm:py-4 lg:py-6 text-gray-900 dark:text-slate-100 w-full">
            <SentimentDashboard
              userId={userId}
              onExploreStocks={() => navigate('/stocks-overview')}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WatchlistPage;
